import React, { useEffect, useState } from "react";
import "./VideoSection.css";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VideoSection = () => {
  const [videoUrl, setVideoUrl] = useState("");

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/VideoSection`);
        const fullUrl = resolveUrl(res.data.videoUrl);
        setVideoUrl(fullUrl);
      } catch (err) {
        console.error("Error loading video section:", err);
      }
    };

    fetchVideo();
  }, []);

  if (!videoUrl) return null;

  return (
    <section className="video-section">
      <video
        className="video-bg"
        src={videoUrl}
        autoPlay
        muted
        loop
        playsInline
      ></video>
    </section>
  );
};

export default VideoSection;
